<template>
  <BaseAction>
    <PrimaryButton @click.native="openDialog" light shrink>
      Edit
      <v-icon class="ml-2">mdi-pencil</v-icon>
    </PrimaryButton>
    <ReferenceDialog
      v-if="isOpen"
      :isOpen="isOpen"
      :reference="reference"
      :candidate="candidate"
      @close="closeDialog"
      @updated="$emit('updated')"
      isUpdate
    />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ReferenceDialog from "@/views/offers/components/compliances/dialogs/ReferenceDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  props: {
    candidate: {
      type: Object,
      required: true
    },
    reference: {
      type: Object,
      required: true
    }
  },
  components: {
    BaseAction,
    ReferenceDialog,
    PrimaryButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
